import { render } from "./OrderCommentEditor.vue?vue&type=template&id=307619f2&scoped=true&ts=true"
import script from "./OrderCommentEditor.vue?vue&type=script&lang=ts"
export * from "./OrderCommentEditor.vue?vue&type=script&lang=ts"

import "./OrderCommentEditor.vue?vue&type=style&index=0&id=307619f2&scoped=true&lang=scss"

import exportComponent from "../../../../../../../../../ldplatform/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-307619f2"]])

export default __exports__